import { jsx as _jsx } from "react/jsx-runtime";
import { NoOpLogger, } from '@dossierhq/core';
import { useMemo } from 'react';
import { DossierContext, } from '../../contexts/DossierContext.js';
import { useAdminSchema } from '../../hooks/useAdminSchema.js';
export function DossierProvider({ adapter, client, logger, authKeys, children, }) {
    const { schema, schemaError } = useAdminSchema(client);
    const value = useMemo(() => {
        return {
            adapter,
            client,
            logger: logger ?? NoOpLogger,
            schema,
            schemaError,
            authKeys: authKeys ?? [{ authKey: '', displayName: 'Default' }],
        };
    }, [adapter, client, logger, schema, schemaError, authKeys]);
    return _jsx(DossierContext.Provider, { value: value, children: children });
}
//# sourceMappingURL=DossierProvider.js.map